import '../snippet/en-GB.json';
import '../snippet/de-DE.json';
import '../snippet/nl-NL.json';

Shopware.Component.override('sw-import-export-edit-profile-general', {
    computed: {
        supportedEntities() {
            const supportedEntites = this.$super('supportedEntities')
            supportedEntites.push(
                {
                    value: 'acris_faq',
                    label: this.$tc('acris-faq-import-export-profile.label')
                }
            );

            return supportedEntites;
        }
    },
    methods: {
        shouldDisableObjectType(item) {
            if (item.value === 'acris_faq') {
                return false;
            }
            return this.$super('shouldDisableObjectType', item);
        },
    },
});
